import { fomatTime, fomatTimeStr } from "@/components/common/utils/time";

export function formatAsinNumTrendsByBrand(list) {
	let data_arr = []
	list = list || []
	let ser = {
		name: '搜索词数',
		type: 'column',
		data: [],
	}

	list.forEach(i => {
		ser.data.push([i.key,i.doc_count])
	})
	data_arr.push(ser)

	let op = getOption(data_arr)
	return op
}

function getOption(data_arr) {
	return {
		chart: {
			type: 'column',
			zoomType: 'x',
		},
		title: {
			text: null
		},
		subtitle: {
			text: '点击时间段查询对应的时间'
		},
		xAxis: {
			type: 'category',
			labels: {
				rotation: -45  // 设置轴标签旋转角度
			}
		},
		navigator: {
			series: {
				type: 'column',
				pointRange: null,
				dataGrouping: {
					groupPixelWidth: 10
				}
			}
		},
		plotOptions: {
			series: {
				cursor: 'pointer',
				events : {}
			}
		},
		rangeSelector: {
			selected: 5
		},
		tooltip: {
			formatter: function(o) {
				let html = '<div style="font-size: 16px;">'
				html += `<div style='font-weight: bolder;'>${ this.points[0].key }</div><br/><br/>`
				html += `<div>搜索词数: <span style="color: #F56C6C">${ this.y }</span></div>`
				html += '</div>'
				return html
			},
			shared: true
		},
		// legend: {},
		series: data_arr
	}
}